/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  selectContainer: {
    width: '220px',
    height: '40px',
    // borderRadius: '100px',
    background: theme.palette.secondary.contrastText,
    color: theme.palette.primary.textColor4,
    border: `1px solid ${theme.palette.primary.backgroundColor5}`,
    textAlign: 'left',
    ' & .MuiSelect-icon': {
      color: theme.palette.primary.buttonColor,
    },
    ' & .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  container: {
    width: '213px',
    height: '30px',
    background: theme.palette.secondary.bundleCardBodyBackground,
    color: theme.palette.primary.textColor4,
    textAlign: 'left',
    ' & .MuiSelect-icon': {
      color: theme.palette.primary.buttonColor,
    },
    ' & .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '0.5rem',
      width: '89%',
    },
  },
  csTVContainer: {
    width: '60%',
    height: '2.5rem',
    borderRadius: '6.25rem',
    background: theme.palette.secondary.contrastText,
    color: theme.palette.secondary.dark,
    textAlign: 'left',
    ' & .MuiSelect-icon': {
      color: theme.palette.secondary.errorCTA,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  dropdownCTAContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '3%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '10%',
      height: '6rem',
    },
  },
  dropdownCTA: {
    border: `3px solid ${theme.palette.primary.buttonColor}`,
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    width: '8.625rem',
    height: '2.5rem',
    textTransform: 'capitalize',
    '&:hover': {
      border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
    '&.Mui-disabled': {
      background: theme.palette.primary.buttonInactiveColor,
      border: `none`,
      color: `${theme.palette.primary.contrastText} !important`,
      height: '2.8rem',
      '&:hover': {
        background: theme.palette.primary.disabled,
        color: `${theme.palette.primary.contrastText} !important`,
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
  },
  menuItems: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.mobileToggleColor,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.mobileToggleColor,
    },
    backgroundColor: 'transparent',
    fontFamily: theme.typography.body1.fontFamily,
    fontWeight: theme.typography.body1.fontWeight,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    color: theme.palette.primary.textColor3,
  },
  defaultMenuItem: {
    color: theme.palette.primary.textColor3,
  },
  defaultMenuItemHover: {
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.mobileToggleColor}!important`,
    },
  },
});

export default styles;
